import { render } from "./Publicaties.vue?vue&type=template&id=8cd2c186"
import script from "./Publicaties.vue?vue&type=script&lang=js"
export * from "./Publicaties.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__